import { useCallback } from 'react';
import { gql } from 'apollo-boost';
import { useMutation } from 'shared/apollo';

export const deleteService = gql`
  mutation deleteService(
    $id: Int!,
  ) {
  deleteService(
    id: $id,
  ) {
      id
      success
    }
  }
`;

export function useDeleteService() {
  const { data, isLoading, mutate } = useMutation();
  const run = useCallback((variables, onFinish) => {
    mutate(deleteService, variables, response => {
      if (typeof onFinish === 'function') {
        onFinish(response.deleteService.id);
      }
    });
  }, []);
  return { data, isLoading, run };
}
